import React, { useEffect, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import QuestionContainer from './QuestionContainer'
import { withStyles, makeStyles } from '@material-ui/core/styles'
import { FormHelperText, TextareaAutosize } from '@material-ui/core'

const styles = {
	input: {
		color: 'black',
		fontSize: '1rem',
		backgroundColor: 'rgb(0,0,0,0.12)'
	},
	root: {
		color: 'black'
	},
	focused: {
		color: 'black',
		backgroundColor: 'rgb(0,0,0,0.12)',
		'&$focused': {
			color: 'black',
			backgroundColor: 'rgb(0,0,0,0.12)'
		}
	},
	contained: {
		color: 'black',
		backgroundColor: 'var(--palette-error-main)',
		padding: '8px 0px'
	},
	error: {
		color: 'black',
		backgroundColor: '#F0F6FF',
		padding: '8px 0px'
	}
}

const useLabelStyles = makeStyles({
	root: {
		color: 'black'
	},
	focused: {
		color: 'black',

		'&$focused': {
			color: 'black'
		}
	}
})

const useInputStyles = makeStyles({
	root: {
		color: 'black',
		'& input': {
			backgroundColor: 'rgb(0,0,0,.12)'
		}
	},
	contained: {
		color: 'black',
		backgroundColor: 'var(--palette-error-main)',
		padding: '8px 0px'
	},
	error: {
		color: 'black',
		backgroundColor: '#F0F6FF',
		padding: '8px 0px'
	}
})

export default ({
	question,
	position,
	positionDisplay,
	input,
	value,
	classes,
	maxLength,
	meta: { touched, invalid, error },
	inputProps,
	disabled,
	onQuestionValueChanged,
	isBilateral,
	isBilateralFullInfo,
	displayInstructionAsIcon,
	uniqueKey,
	...custom
}) => {
	const isLabelContainerPreserved = !!isBilateral && !!isBilateralFullInfo
	var labelStyles = useLabelStyles()
	var inputStyles = useInputStyles()
	const [errorText, setErrorText] = useState(null)
	const [validationTimeoutId, setValidationTimeoutId] = useState(null)

	useEffect(
		() => {
			clearTimeout(validationTimeoutId)
			if(touched
				&& invalid
				&& error){
					let timeout = setTimeout(() => setErrorText(error), 200)
					setValidationTimeoutId(timeout)
				}
			else {
				setValidationTimeoutId(null)
				setErrorText(null)
			}
		},
		[touched, invalid, error]
	)

	const onChange = (e) => {
		onQuestionValueChanged(question, e.target.value)
	}

	return (
		<Grid>
			<QuestionContainer
				data-testid="text-question"
				title={`${question.title}`} titleRequered = {`${question.isOptional ? '' : ' *'}`}
				position={position}
				positionDisplay={positionDisplay}
				instructions={question.instructions}
				isBilateral={isBilateral}
				displayInstructionAsIcon={displayInstructionAsIcon}
				children={
					<Grid
						container
					>
						{
							!!isLabelContainerPreserved
							&& <Grid xs={6} />
						}
						<Grid
							item
							xs={isLabelContainerPreserved ? 6 : 12}
						>
							<TextareaAutosize
								data-testid="text-question-field"
								disabled={disabled}
								type='text'
								variant='filled'
								error={touched && invalid}
								InputProps={{
									classes: {
										input: inputStyles.input
									},
									inputProps: { maxLength: maxLength, style: { color: 'black' } }
								}}
								inputProps={{
									...inputProps,
									maxLength: 255
								}}
								InputLabelProps={{
									classes: {
										root: labelStyles.root,
										focused: labelStyles.focused
									}
								}}
								style={{
									width: '100%'
								}}
								value={value}
								onChange={onChange}
								multiline={true}
								{...custom}
								{...input}
							/>
							{
								errorText
								&& <FormHelperText
									className="errorWrapper"
									data-testid="text-question-error"
								>
									{errorText}
								</FormHelperText>
							}
						</Grid>
					</Grid>
				}
			/>
		</Grid>
	)
}
